// extracted by mini-css-extract-plugin
export var container = "_bi-1";
export var cornerButtonContainer = "_bi-5";
export var disabled = "_bi-2";
export var fileContainer = "_bi-4";
export var hiddenInput = "_bi-3";
export var widthContainer = "_bi-0";